import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { Button, Row, Col, Nav, Tab, Card } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { getFromLS, setToLS } from "../../utils/storage";
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider.js";

// Themes setting
import themes from "../../themes/themes.json";
import chart_themes from "../../themes/chart_themes.json";

// Dashboard Pills
import VendorDetails from "../vendorDetails";
import ManageUsers from "../ManageUsers";
import MyFlows from "../MyFlows";
import ReportDashboard from "../ReportDashboard/ReportDashboard";
import MaintanenceReports from "../MaintanenceReports";
import FormLayout from "../DynamicForm/layout";
import MyForms from "../DynamicForm/myforms/myforms";
import MyKones from "../K1/K1LandingPage/konehome";
import InternalK1 from "../internalK1-ts/internalK1.tsx";
import Tieout from "pages/tieout-ts/tieout";
import LandingPage from "pages/LandingPage/LandingPage";
// import InternalK1 from "../InternalK1/InternalK1.js";
import K1Bots from "../K1Bots/K1Bots.js";

import ClientOnboarding from "../../separate_apps/ClientOnboarding/clientonboarding.js";
import TaskCreation from "../TaskCreation/taskcreation";

import ComingSoonTemplate from "../reports/ComingSoonTemplate/ComingSoonTemplate.js";
import WorkDistributionReport from "../reports/WorkDistributionReport/WorkDistributionReport";
import ClientOnboardingConfigFlow from "../../separate_apps/ClientOnboarding/clientonboardingconfigflow.js";
import { ConfirmationModal } from "./ConfirmationModal";
import { logout } from "../../utils/index.js";
import ClientsPage from "pages/Clients/ClientsPage";

const Dashboard = () => {
  // User details
  const firm_id = localStorage.getItem("firmId");
  const user = localStorage.getItem("user");
  const usertype = localStorage.getItem("usertype");
  const firmname = localStorage.getItem("firmname")
  const availableFeatures = getFromLS("active-features")
  // console.log("Available features = ", availableFeatures)
  const auth = useAuth();
  const navigate = useNavigate()

  const handleLogout = () => {
    auth.logout();
    localStorage.removeItem("token");
    localStorage.removeItem("firmId");
    localStorage.removeItem("user");
    localStorage.removeItem("username");
    localStorage.removeItem("usertype");
    localStorage.removeItem("firmname");
    localStorage.setItem("active-features", []);
    // localStorage.clear()
    navigate("/login");
  };

  const clearCache = () => {
    localStorage.clear();
    window.location.reload();
    // navigate(currPath)
  };

  const setThemer = (result) => {
    console.log("SET THEMER: ", result)
    // console.log("GET THEME api result: ", JSON.parse(result.data[0].params[0].parameter_value_1))
    // setAllThemes(JSON.parse(result.data[0].params[0].parameter_value_1));
    if (result.data[0].params.length > 0) {
      setToLS(
        "all-themes",
        JSON.parse(result.data[0].params[0].parameter_value_1)
      );
    }
    // console.log("After setting allThemes: ", allThemes)
  };

  const getThemes = () => {
    const parameter_name = "themes";
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ firm_id, parameter_name }),
    };
    // console.log('Get themes requestOptions:`, requestOptions)
    fetch(
      `${process.env.REACT_APP_BASE_URI}/workflow/personalization/get_params/`,
      requestOptions
    )
      .then((result) => result.json())
      .then((res) => setThemer(res));
  };

  useEffect(() => {
    getThemes();
    getActiveThemes(true) // for chart theme
    getActiveThemes(false) // for normal theme
  }, []);

  const setActiveThemes = (chart, activeTheme) => {
    const parameter_value_1 = JSON.stringify(activeTheme);
    const parameter_name = chart ? "activeChartTheme" : "activeTheme";
    const payload = { firm_id, parameter_name, parameter_value_1 };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    };
    fetch(
      `${process.env.REACT_APP_BASE_URI}/workflow/personalization/set_params/`,
      requestOptions
    ).then((result) => result.json());
  };

  const getActiveThemes = (chart) => {
    const parameter_name = chart ? "activeChartTheme" : "activeTheme";
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ firm_id, parameter_name }),
    };
    fetch(
      `${process.env.REACT_APP_BASE_URI}/workflow/personalization/get_params/`,
      requestOptions
    )
      .then((result) => result.json())
      .then((res) => storeActiveThemeValues(chart, res))
  }

  const storeActiveThemeValues = (chart, res) => {
    if (res.data[0].params.length === 0 && !chart) {
      setActiveThemes(chart, themes.data["light"])
    } else if (res.data[0].params.length === 0 && chart) {
      setActiveThemes(chart, chart_themes.data["Tableau Classic 10"])
    } else {
      // setActiveThemes(false, themes.data["light"])
      // setActiveThemes(true, chart_themes.data["Tableau Classic 10"])
      !chart ? setToLS("theme", JSON.parse(res.data[0].params[0].parameter_value_1)) : setToLS("chart-theme", JSON.parse(res.data[0].params[0].parameter_value_1))
      // window.location.reload()
    }
  }

  // Sidenav open close feature
  let [isOpen, setIsOpen] = useState(false);
  let [forcedOpen, setForcedOpen] = useState(false);
  let [logoutIcon, setLogoutIcon] = useState(false)
  const openNav = () => {
    document.getElementById("mySidenav").style.width = "250px";
    document.getElementById("dashboard-content").style.marginLeft = "250px";
    setTimeout(() => {
      setIsOpen(true);
    }, 0);
  };
  const closeNav = () => {
    document.getElementById("mySidenav").style.width = "70px";
    document.getElementById("dashboard-content").style.marginLeft = "70px";
    setIsOpen(false);
  };

  const sidenavOpenDoor = () => {
    setLogoutIcon(true)
  }
  const sidenavCloseDoor = () => {
    setLogoutIcon(false)
  }
  // Setting default opening pill based on user (this is hard coded right now)
  // Done in Login.js

  // Navigate with props to bring in dynamic behaviour
  /**
   * 
   * @param {*} pill : This arguement tells us where to navigate, there is no default value.
   * @param {*} mapping_option : This arguement is by default null and is only used when navigating to mapping page.
   * @param {*} report_navigator : This is a boolean arguement which tells us if navigation is within Intelligence
   *                               report and we then do not need to update dashboard nav-pills
   */
  const navigateWithData = (pill, options = { mapping_option: null, credential_option: null, maintenancereport_option: null, automationreport_option: null, createform_option: null, report_navigator: false }) => {
    const mapping_option = options.mapping_option;
    const credential_option = options.credential_option;
    const maintenancereport_option = options.maintenancereport_option;
    const createform_option = options.createform_option;
    const automationreport_option = options.automationreport_option;
    const report_navigator = options.report_navigator;
    if (pill != undefined && pill.length != 0) {
      if (report_navigator) {
        // here we only navigate to report but do not change the active dashboard pill
        setRender(RENDER_MAP[pill]);
      } else if (mapping_option != null || mapping_option != undefined) {
        // here we navigate to mapping with a mapping_option for pre-selected dropdown
        // change the active dashboard pill to mapping
        setActiveKey(pill);
      } else if (credential_option != null || credential_option != undefined) {
        // here we navigate to credentials with a credential_option for pre-selected dropdown
        // change the active dashboard pill to credentials
        setActiveKey(pill);
        setRender(CustomCredentialRender(credential_option));
      } 
      else if (maintenancereport_option != null || maintenancereport_option != undefined) {
        // here we navigate to credentials with a maintenancereport_option for pre-selected dropdown
        // change the active dashboard pill to maintenancereport
        setActiveKey(pill);
        setRender(CustomMaintenanceReportRender(maintenancereport_option));
      }
      else if (createform_option != null || createform_option != undefined) {
        // here we navigate to credentials with a automationreport_option for pre-selected option
        // change the active dashboard pill to createform
        console.log("ACTIVE PILL BEING SET WHEN GONE THROUGH!", pill)
        setActiveKey(pill);
        setRender(CustomFormLayoutRender(createform_option));
      }
      else {
        // here we navigate to pill and change the active dashboard pill to selected Pill
        if (["dynamicform"].includes(activeKey)) {
          setConfirmationModal(true)
          setNavigationData(pill)
        } else {
          setActiveKey(pill);
          setRender(RENDER_MAP[pill]);
        }
      }

    } else if (pill != "empty") {
      setRender(RENDER_MAP[pill]);

    } else {
      console.log("NO PAGE FOUND TO NAVIGATE.")
    }
  };

  




  const CustomCredentialRender = (credential_option) => {
    // console.log("IS THIS CUSTOM FUNCTION BEING CALLED?", credential_option)
    return (
      <VendorDetails credentialoption={credential_option} transporter={navigateWithData} />
    )
  }

  const CustomFormLayoutRender = (createform_option) => {
    // console.log("IS THIS CUSTOM FUNCTION BEING CALLED?", createform_option)
    return (
      <FormLayout createformoption={createform_option} transporter={navigateWithData} />
    )
  }

  const CustomMaintenanceReportRender = (report_option) => {
    // console.log("IS THIS CUSTOM FUNCTION BEING CALLED?", report_option)
    return (
      <MaintanenceReports reportoption={report_option} transporter={navigateWithData} />
    )
  }

  const redirectToClientDM = () => {
    let url = null
    if (process.env.REACT_APP_ENV == "dev") {
      url = process.env.REACT_APP_DEV_CLIENT_DATAMANAGEMENT_URL;
    }
    else if (process.env.REACT_APP_ENV == "prod") {
      url = process.env.REACT_APP_PROD_CLIENT_DATAMANAGEMENT_URL;
    }

    if (url) {
      window.open(url, '_blank');
    }
    else {
      console.error("invalid environment configuration")
    }
  }

  /**
   *  Global mapper for page navigation
   *                                !!!!! WARNING !!!!
   *  Please do not change any of the existing keys in RENDER_MAP as they are being used in different places. 
   *                       Doing so may end up breaking the functionality.
   */
  const RENDER_MAP = {
    // Admins
    // Dashboard pills: Page component
    myflows: <MyFlows transporter={navigateWithData} />,
    credentials: <CustomCredentialRender />,
    manage: <ManageUsers transporter={navigateWithData} />,
    maintenancereport: <CustomMaintenanceReportRender />,
    dynamicform: <CustomFormLayoutRender />,
    myforms: <MyForms transporter={navigateWithData} />,
    mykones: <MyKones transporter={navigateWithData} />,
    clientonboarding: <ClientOnboarding transporter={navigateWithData} />,
    clientonboardingconfig: <ClientOnboardingConfigFlow transporter={navigateWithData} />,
    internalk1: <InternalK1 transporter={navigateWithData} />,
    k1bots: <K1Bots transporter={navigateWithData} />,
    tieout: <Tieout transporter={navigateWithData} />,
    landing: <LandingPage transporter={navigateWithData} />,
    clientSearch: <ClientsPage transporter={navigateWithData} />,
    // INNTERNAL REPORTS NAVIGATOR
    // Intelligence reports pills: Report component

    ComingSoonTemplate: <ComingSoonTemplate transporter={navigateWithData} />
  };

  const [render, setRender] = useState(RENDER_MAP["clientSearch"]);
  const [activeKey, setActiveKey] = useState("clientSearch");
  const [openApplication, setOpenApplication] = useState(true);
  const [openProfile, setOpenProfile] = useState(true);
  const [openInsights, setOpenInsights] = useState(true);
  const [confirmationModal, setConfirmationModal] = useState(false)
  const [navigationData, setNavigationData] = useState({})

  const continueNavigation = (navigationData) => {
    setActiveKey(navigationData);
    setRender(RENDER_MAP[navigationData]);
  }


  const InsightsToggle = ({ children, eventKey }) => {
    const decoratedOnClick = useAccordionButton(eventKey, () =>
      setOpenInsights(!openInsights)
    );

    return (
      <Nav.Link eventKey="" onClick={decoratedOnClick}>
        <Icon.Clipboard2DataFill />
        {isOpen ? <p>&nbsp;External&nbsp;K1s {children}
          {openInsights
            ?
            <Icon.ChevronRight className="chevy" />
            :
            <Icon.ChevronDown className="chevy" />
          }
        </p> : ""}

      </Nav.Link>
    );
  }

  const ProfileToggle = ({ children, eventKey }) => {
    const decoratedOnClick = useAccordionButton(eventKey, () =>
      setOpenProfile(!openProfile)
    );

    return (
      <Nav.Link eventKey="" onClick={decoratedOnClick}>
        <Icon.PersonFillGear />
        {isOpen ? <p>&nbsp;My&nbsp;Profile {children}
          {openProfile
            ?
            <Icon.ChevronRight className="chevy" />
            :
            <Icon.ChevronDown className="chevy" />
          }
        </p> : ""}

      </Nav.Link>
    );
  }

  const ApplicationToggle = ({ children, eventKey }) => {
    const decoratedOnClick = useAccordionButton(eventKey, () =>
      setOpenApplication(!openApplication)
    );

    return (
      <Nav.Link eventKey="" onClick={decoratedOnClick}>
        <Icon.XDiamondFill />
        {isOpen ? <p>Other&nbsp;Applications {children}
          {openApplication
            ?
            <Icon.ChevronRight className="chevy" />
            :
            <Icon.ChevronDown className="chevy" />
          }
        </p> : ""}

      </Nav.Link>
    );
  }

  

  return (
    <>
      <div className="wrapper">
        <div
          id="mySidenav"
          className="sidenav"
          onMouseEnter={() => openNav()}
          onMouseLeave={() => forcedOpen ? console.log() : closeNav()}
        >
          <ConfirmationModal
            show={confirmationModal}
            onHide={() => setConfirmationModal(false)}
            navigationdata={navigationData}
            stayandsave={() => setConfirmationModal(false)}
            skipandleave={(navigationData) => {
              setConfirmationModal(false)
              continueNavigation(navigationData)
            }
            }
          />
          <Tab.Container
            id="left-tabs-example"
            activeKey={activeKey}
            defaultActiveKey={activeKey}
            className="flex-row-space-center"
          >
            <Nav variant="pills" defaultActiveKey={activeKey} style={{ marginBottom: 50 }}>
              {
                <div className="flex-row-center-start go-home" onClick={() => navigate("/dashboard")}>
                  <img className="sidenav-dashboard-logo" src={require("../../images/dashboard_logo.png")} />
                  <p className="typing-text">{isOpen ? <p>&nbsp;Cygnus&nbsp;Tax&nbsp;</p> : ""}</p>
                  <div className={forcedOpen ? isOpen ? "sidenav-open" : "sidenav-lock" : "sidenav-lock"}>
                    {
                      forcedOpen ? <Icon.LockFill onClick={() => setForcedOpen(false)} /> : <Icon.UnlockFill onClick={() => setForcedOpen(true)} />
                    }
                  </div>
                </div>
              }
              <hr className="sidenav-divider" />
              {
               
               <Nav.Item onClick={() => navigateWithData("clientSearch")}>
                 <Nav.Link eventKey="clientSearch">
                   <Icon.FastForward />
                   {isOpen ? <p>&nbsp;Clients&nbsp;</p> : ""}
                 </Nav.Link>
               </Nav.Item>
             }
              
              {/* {                
                <Nav.Item onClick={() => navigateWithData("internalk1")}>
                  <Nav.Link eventKey="internalk1">
                    <Icon.Diagram3Fill />
                    {isOpen ? <p>&nbsp;Internal&nbsp;k1&nbsp;</p> : ""}
                  </Nav.Link>
                </Nav.Item>
              } */}
              {/* {
               
               <Nav.Item onClick={() => navigateWithData("tieout")}>
                 <Nav.Link eventKey="tieout">
                   <Icon.UiChecksGrid />
                   {isOpen ? <p>&nbsp;K1&nbsp;Tieout&nbsp;</p> : ""}
                 </Nav.Link>
               </Nav.Item>
             } */}
             {
               
               <Nav.Item onClick={() => navigateWithData("myflows")}>
                 <Nav.Link eventKey="myflows">
                   <Icon.LayersFill />
                   {isOpen ? <p>&nbsp;Flows&nbsp;</p> : ""}
                 </Nav.Link>
               </Nav.Item>
             }

          {


                    <Nav.Item onClick={() => navigateWithData("maintenancereport")}>
                    <Nav.Link eventKey="maintenancereport">
                      <Icon.GearWideConnected />
                      {isOpen ? <p>&nbsp;Reports&nbsp;</p> : ""}
                    </Nav.Link>
                    </Nav.Item>
                
                
              }
              
         
     
              {
                (usertype == "FirmAdmin" && availableFeatures.includes("K1_FRM")) &&
                <Accordion className="sidenav-dropdown">
                  <Nav.Item>
                    <ApplicationToggle eventKey="0"></ApplicationToggle>
                  </Nav.Item>
                  <Accordion.Collapse eventKey="0">
                    <>
                      {                        
                        <Nav.Item onClick={() => redirectToClientDM()}>
                          <Nav.Link eventKey="redirecttomdm">
                            <Icon.ArrowUpRightSquareFill />
                            {isOpen ? <p>&nbsp;Client Data Management&nbsp;</p> : ""}
                          </Nav.Link>
                        </Nav.Item>
                      }
                    </>
                  </Accordion.Collapse>
                </Accordion>
              }
              {
                <Row className="sidenav-bottom-container">
                  <div className="sidenav-firm-icon">
                    <Icon.PersonWorkspace style={{ height: 25, width: 25 }} />
                  </div>
                  <div style={{ width: "fit-content", padding: 0, marginLeft: 5 }}>
                    {isOpen ? <p style={{ fontSize: "var(--small_font)", margin: 0 }}>Logged&nbsp;in&nbsp;from&nbsp;</p> : ""}
                    {isOpen ? <p style={{ fontWeight: 600, marginTop: 0, width: 80, maxWidth: 80 }}>{firmname}</p> : ""}
                  </div>
                  {
                    isOpen
                      ?
                      <div
                        className="sidenav-logout-container"
                        onMouseEnter={() => sidenavOpenDoor()}
                        onMouseLeave={() => sidenavCloseDoor()}>
                        {
                          logoutIcon
                            ?
                            <span onClick={() => logout()}><Icon.DoorOpenFill className="sidenav-logout" />&nbsp;Logout</span>
                            :
                            <span onClick={() => logout()}><Icon.DoorClosedFill className="sidenav-logout" />&nbsp;Logout</span>
                        }
                      </div>
                      :
                      <></>
                  }
                </Row>
              }
            </Nav>
          </Tab.Container>
        </div>
        <div
          id="dashboard-content"
          className={activeKey === "clientSearch" ? "dashboard-content--clients" : ""}
        >
          {render}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
